export default __webpack_public_path__ + "static/media/refer-and-get-reward-en.a62f74c0.svg";